/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// vue meta
import vueMeta from 'vue-meta'

Vue.use(vueMeta)

// axios
import axios from './axios.js'

Vue.prototype.$http = axios

// export to excel
import excel from 'vue-excel-export'

Vue.use(excel)


// i18n
import i18n from './i18n/i18n'

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router/meta'


// Vuex Store
import store from './store/store'

// Environment
import env from './environment/environment'

Vue.use(env)

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer)

// pusher
import Echo from 'laravel-echo'

/*require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'saeed123',
  wsHost: 'core.useral.com',
  wsPort: 6001,
  wssPort: 6001,
  forceTLS: true,
  disableStats: true,
  authEndpoint: 'https://core.useral.com/broadcasting/auth',
});*/


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Font Awesome icon
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import * as lightIcons from '@fortawesome/pro-light-svg-icons'

const iconList = Object.keys(lightIcons)
  .filter(key => key.startsWith('fa'))
  .map(key => lightIcons[key])

library.add(...iconList)

import * as solidIcons from '@fortawesome/pro-solid-svg-icons'

const iconSolidList = Object.keys(solidIcons)
  .filter(key => key.startsWith('fa'))
  .map(key => solidIcons[key])

library.add(...iconSolidList)

import * as duotoneIcons from '@fortawesome/pro-duotone-svg-icons'

const iconDuotoneList = Object.keys(duotoneIcons)
  .filter(key => key.startsWith('fa'))
  .map(key => duotoneIcons[key])

library.add(...iconDuotoneList)

import * as kitIcons from '@awesome.me/kit-056688db4a/icons/js/all'

const iconKitList = Object.keys(kitIcons)
  .map(key => kitIcons[key])

library.add(...iconKitList)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// Feather font icon
require('./assets/css/iconfont.css')

// opensans font
require('./assets/css/opensans.css')

// iransans font
require('./assets/css/iransans.css')

// helvetica font
require('./assets/css/helvetica.css')

// roboto font
require('./assets/css/roboto.css')

// rubik font
require('./assets/css/rubik.css')

// draggable dynamic table
import DraggableDynamicTable from '@/components/draggableDynamicTable/draggableDynamicTable'
Vue.component('DraggableDynamicTable', DraggableDynamicTable)

// import vue directives
import './directives'

// import tooltips
import TooltipPlugin from '@/plugins/tooltip'

Vue.use(TooltipPlugin)

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// import prototypes
import './prototypes'


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
